import { type EmailBasicDto, NewEmailDataDto } from '@/api/generated';
import { EmailSelectOption } from '@/components/form/model/SelectSearchOption.model.ts';
import { Override } from '@/utils/Override.utilityType.ts';

export type NewEmailFormModel = Override<
  NewEmailDataDto,
  {
    bcc: EmailSelectOption[];
    cc: EmailSelectOption[];
    to: EmailSelectOption[];
  }
> & {
  emailId: string;
  threadId: string;
};

export const mapEmailToSelectOption = (email: string): EmailSelectOption => {
  return {
    email: email,
    label: email,
    value: email,
  };
};

export const initNewEmailFormModel = (params: {
  email?: EmailBasicDto | void;
  userEmail: string;
}): NewEmailFormModel => {
  const { email, userEmail } = params;

  if (email) {
    return {
      bcc: email.bcc.map(mapEmailToSelectOption),
      body: email.body,
      cc: email.cc.map(mapEmailToSelectOption),
      emailId: email.emailId,
      from: userEmail,
      subject: email.subject,
      threadId: email.threadId,
      to: email.to.map(mapEmailToSelectOption),
    };
  }

  throw new Error('No new email data available');
};
